const styles = theme => ({
    root: {
    },
    alert: {
        marginTop: theme.spacing(3),
    }
});

export default styles;